import React from 'react';
import './SubscriptionModal.css';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SubscriptionModal: React.FC<SubscriptionModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleStartTrial = () => {
    // In a real app, this would trigger Stripe/Vipps
    window.location.href = '/settings?showCheckout=true';
  };

  return (
    <div className="sub-modal-overlay" onClick={onClose}>
      <div className="sub-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="sub-modal-close" onClick={onClose}>&times;</button>
        
        <div className="sub-modal-header">
          <div className="pro-badge">PRO</div>
          <h1>{t("auto.subscriptionmodal.fricamp_pro", "Fricamp Pro")}</h1>
          <p className="sub-tagline">{i18n.t('subscription.tagline', 'Unlock the full adventure')}</p>
        </div>

        <div className="perks-list">
          <div className="perk-item">
            <div className="perk-icon">🛣️</div>
            <div className="perk-text">
              <h3>{i18n.t('subscription.offroad_title', 'Offroad Routes')}</h3>
              <p>{i18n.t('subscription.offroad_desc', 'Get access to curated offroad and gravel routes.')}</p>
            </div>
          </div>
          <div className="perk-item">
            <div className="perk-icon">🗺️</div>
            <div className="perk-text">
              <h3>{i18n.t('subscription.offline_title', 'Offline Maps')}</h3>
              <p>{i18n.t('subscription.offline_desc', 'Download maps for use without cellular coverage.')}</p>
            </div>
          </div>
          <div className="perk-item">
            <div className="perk-icon">✨</div>
            <div className="perk-text">
              <h3>{i18n.t('subscription.exclusive_title', 'Exclusive Spots')}</h3>
              <p>{i18n.t('subscription.exclusive_desc', 'Discover hidden gems only available to Pro members.')}</p>
            </div>
          </div>
        </div>

        <div className="sub-modal-footer">
          <button className="btn-primary-pro" onClick={handleStartTrial}>
            {i18n.t('subscription.start_trial', 'Start 7-Day Free Trial')}
          </button>
          <p className="price-info">{i18n.t('subscription.price_info', 'Then 49 NOK / month. Cancel anytime.')}</p>
          <button className="btn-secondary-link" onClick={() => window.location.href = '/settings'}>
            {i18n.t('subscription.restore_purchase', 'Already a member? Restore purchase')}
          </button>
        </div>
      </div>
    </div>
  );
};
